/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

export type AgencyProfileLinkResponseDtoType = typeof AgencyProfileLinkResponseDtoType[keyof typeof AgencyProfileLinkResponseDtoType];


export const AgencyProfileLinkResponseDtoType = {
  FACEBOOK: 'FACEBOOK',
  INSTAGRAM: 'INSTAGRAM',
  YOUTUBE: 'YOUTUBE',
  LINKEDIN: 'LINKEDIN',
  TIKTOK: 'TIKTOK',
  WEBSITE: 'WEBSITE',
  OTHER: 'OTHER',
} as const;
